export default __webpack_public_path__ + "static/media/Img0020.29f3da78.png";